import { Action, createReducer, on } from '@ngrx/store';

import * as fromActions from './actions';
import * as fromState from './state';

export const reducer = createReducer(
  fromState.initialState,
  on(fromActions.loadBookingEngineFirstStepRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(fromActions.loadBookingEngineFirstStepSuccess, (state, { data }) => ({
    ...state,
    isLoading: true,
    error: null,
    firstStep: data,
  })),

  on(fromActions.loadBookingEngineFirstStepFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(fromActions.loadBookingEngineSecondStepRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(fromActions.loadBookingEngineSecondStepSuccess, (state, { data }) => ({
    ...state,
    isLoading: true,
    error: null,
    secondStep: data,
  })),

  on(fromActions.loadBookingEngineSecondStepFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(fromActions.loadBookingEngineRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(fromActions.loadBookingEngineSuccess, (state, { data }) => ({
    ...state,
    isLoading: true,
    error: null,
    data,
  })),

  on(fromActions.loadBookingEngineFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
  on(fromActions.resetBookingEngineState, () => fromState.initialState),
);

export function bookingEngineReducer(
  state: fromState.State | undefined,
  action: Action,
) {
  return reducer(state, action);
}
